import Patient from "@/models/Patient";

export function mutLoading(state: any, loading: boolean): void {
  state.loading = loading;
}
export function mutprocedureSelectid(state: any, procedureid: number): void {
  state.procedureSelectid = procedureid;
}
